let locales = {
    "httpLog_user": "Utente",
    "httpLog_date": "Data e ora",
    "httpLog_originLink": "Link provenienza",
    "httpLog_destinyLink": "Link destinazione",
    "httpLog_ip": "IP"
};

export default locales;